// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"652":"6137c265","829":"6137c265"}[chunkId] + ".css";
};